import gql from 'graphql-tag';

export const CREATE_WELCOME_MESSAGE_LOCALIZATION_MUTATION = gql`
  mutation CreateWelcomeMessageLocalization($data: updateWelcomeMessageInput!) {
    createWelcomeMessageLocalization(input: $data) {
      id
      title
      subtitle
      bodyText
      locale
    }
  }
`;
